module.exports = __webpack_public_path__ + "img/aporng icon 2.de4d3bc5.png";